import React from 'react';
import { useTranslation } from 'react-i18next';
import { TimesCircleIcon } from 'assets/icons';
import { theme } from 'styles';
import { Flex, Icon, MarginBox, Text } from 'UI';
import {
  ReferenceUnavailableForOrderWrapper,
  ReferenceUnavailableWrapperMedium,
  ReferenceUnavailableWrapperSmall,
} from './ReferenceUnavailable.styled';

type ProductReferenceUnavailableSizeType = 'small' | 'medium';

interface ProductReferenceUnavailableProps {
  size?: ProductReferenceUnavailableSizeType;
  message?: string;
}

export const ReferenceUnavailable = ({ size = 'small', message }: ProductReferenceUnavailableProps) => {
  const { t } = useTranslation();
  const ReferenceUnavailableWrapper =
    size === 'small' ? ReferenceUnavailableWrapperSmall : ReferenceUnavailableWrapperMedium;

  return (
    <ReferenceUnavailableWrapper>
      <MarginBox mr={15} />
      <Icon IconComponent={TimesCircleIcon} color={theme.color.palette_red_7} width={25} height={25} />
      <MarginBox mr={5} />
      <Text type="base" color="grey25">
        {message ?? t('catalog.reference.unavailable', 'Looks like this item is not available in your country.')}
      </Text>
      <MarginBox mr={15} />
    </ReferenceUnavailableWrapper>
  );
};

interface ReferenceUnavailableForOrderProps {
  enabled?: boolean;
  message?: string;
}

export const ReferenceUnavailableForOrder = ({ enabled = false, message }: ReferenceUnavailableForOrderProps) => {
  const { t } = useTranslation();
  if (!enabled) {
    return null;
  }
  return (
    <ReferenceUnavailableForOrderWrapper>
      <Flex direction={'row'} align={'center'}>
        <Icon IconComponent={TimesCircleIcon} color={theme.color.palette_red_7} width={18} height={18} />
        <MarginBox mr={10} />
        <Text type="sm" color="grey35">
          {message ??
            t(
              'catalog.reference.order_unavailable.error_message',
              'Please contact your Dealer to place an order for this reference.',
            )}
        </Text>
      </Flex>
    </ReferenceUnavailableForOrderWrapper>
  );
};
